import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSidebar } from '../context/SidebarContext';
import menuicon from '../image/menu.svg';

const Header = () => {
  const { toggleSidebar, isOpen } = useSidebar();
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdown, setDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setDropdown(false);
    navigate('/login');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const generateTitleFromPath = (path) => {
    const parts = path.split('/').filter(Boolean);
    if (parts.length === 0) return 'Dashboard';
    const lastPart = parts[parts.length - 1];
    return lastPart
      .replace(/[-_]/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const generateSubtitle = (title) => {
    const subtitles = {
      'Dashboard': 'View and Manage Dashboard',
      'Bookings': 'View and Manage All Bookings',
      'Bookings Management': 'View and Manage All Bookings',
      'Sports': 'View and Manage All Sports',
      'Sports Management': 'View and Manage All Sports',
      'Courts': 'View and Manage All Courts',
      'Courts Management': 'View and Manage All Courts',
      'Users': 'View and Manage All Users',
      'User Management': 'View and Manage All Users',
    };
    return subtitles[title] || `View and Manage ${title}`;
  };

  const currentPageTitle = generateTitleFromPath(location.pathname);
  const currentSubtitle = generateSubtitle(currentPageTitle);

  const sidebarWidth = isOpen ? '270px' : '60px';

  return (
    <div
      style={{
        background: '#f1f5f9',
        color: '#000000',
        padding: '0.75rem 1rem',
        marginLeft: sidebarWidth,
        position: 'fixed',
        zIndex: 1020,
        width: `calc(100% - ${sidebarWidth})`,
        borderTopLeftRadius: '50px',
        top: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        transition: 'margin-left 0.3s ease, width 0.3s ease',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <button
            className="sidebar-menu-toggle"
            onClick={toggleSidebar}
            style={{ marginRight: '16px', background: 'none', border: 'none', padding: 0 }}
          >
            <img src={menuicon} alt="menuicon" />
          </button>
        <div style={{ marginLeft: '1rem' }}>
          <h2
            style={{
              margin: '0 0 0.25rem 0',
              padding: 0,
              fontWeight: 600,
              fontSize: '1.125rem',
              color: '#000000',
              lineHeight: 1.2,
              textAlign: 'left',
            }}
          >
            {currentPageTitle}
          </h2>
          <span
            style={{
              color: 'lightslategray',
              fontWeight: 600,
              fontSize: '0.875rem',
              margin: 0,
              padding: 0,
              lineHeight: 1.2,
              display: 'block',
              textAlign: 'left',
            }}
          >
            {currentSubtitle}
          </span>
        </div>
      </div>

      <div
        ref={dropdownRef}
        style={{
          position: 'relative',
          cursor: 'pointer',
        }}
        onClick={() => setDropdown(!dropdown)}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          <span style={{ fontWeight: 600, fontSize: '0.875rem' }}>Admin</span>
          <div
            style={{
              width: '30px',
              height: '30px',
              borderRadius: '50em',
              background: '#1976d2',
              border: '2px solid #fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontWeight: 600,
              fontSize: '0.875rem',
            }}
          >
            A
          </div>
        </div>

        {dropdown && (
          <div
            style={{
              position: 'absolute',
              top: '44px',
              background: '#fff',
              minWidth: '250px',
              padding: '0 0 1rem 0',
              borderRadius: '0.5rem',
              boxShadow: '0 0 30px 2px rgba(0,0,0,0.15)',
              right: 0,
              zIndex: 1030,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '0.5rem 1rem',
                background: 'linear-gradient(45deg, #1d3160, #a3abbe)',
                borderTopLeftRadius: '0.5rem',
                borderTopRightRadius: '0.5rem',
                color: '#fff',
              }}
            >
              <div
                style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: '#fff',
                  color: '#1d3160',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 600,
                  marginRight: '0.75rem',
                  fontSize: '1.5rem',
                }}
              >
                A
              </div>
              <div>
                <h6 style={{ color: '#fff', margin: '0 0 0.25rem 0' }}>Admin</h6>
                <p style={{ margin: 0, fontSize: '0.85rem', color: '#fff' }}>admin@absportsacademy.in</p>
              </div>
            </div>
            <div
              style={{ cursor: 'pointer', padding: '10px 15px' }}
              onClick={handleLogout}
            >
              Logout
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;